import { PlaceState, Place } from './types';
import { UserState } from '../users/types';

export function allTags(state: PlaceState) {
  return ['All', 'Visited', 'BucketList', 'Favorites'];
}

export function allPlaces (state: PlaceState) {
  const array = JSON.parse(JSON.stringify(state.places));

  if (state.visitedPlaces) {
    const visitedKeys = Object.keys(state.visitedPlaces);
    if (visitedKeys.length > 0) {
      visitedKeys.forEach((item: any) => {
        array.push(state.visitedPlaces[item]);
      });
    }
  }
  if (state.bucketList) {
    const bucketKeys = Object.keys(state.bucketList);
    if (bucketKeys.length > 0) {
      bucketKeys.forEach((item: any) => {
        array.push(state.bucketList[item]);
      });
    }
  }
  return array;
}
export function isVisitedPlace(id: string, myList: any) {
  if (!myList || !myList[id] || !myList[id].tags) {
    return false;
  }
  return myList[id].tags.indexOf('visited') >= 0;
}

export function isInFavorite(id: string, myList: any) {
  if (!myList || !myList[id] || !myList[id].tags) {
    return false;
  }
  return myList[id].tags.indexOf('favorites') >= 0;
}

export function isInBucketList(id: string, myList: any) {
  if (!myList || !myList[id] || !myList[id].tags) {
    return false;
  }
  return myList[id].tags.indexOf('bucket') >= 0;
}

export function allFiltered(state: PlaceState) {
  const searchFilter = searchText(state.searchTextInHome);
  const stateFilter = filterByState(state.stateFilters)
  const filtered = state.places
    .filter(searchFilter)
    .filter(stateFilter);
  return filtered;
}

export function allFilteredPlacesOnHomeView(state: PlaceState) {
  state.placesOnDisplayInHome.forEach((item) => {
    const { parkCode: id } = item;
    // const { id } = item;
    const isVisited = isVisitedPlace(id, state.myList);
    const isFavorite = isInFavorite(id, state.myList)
    const isBucketList = isInBucketList(id, state.myList)
    const tags = [];
    if (isVisited) {
      tags.push('visited');
    }
    if (isBucketList) {
      tags.push('bucket')
    }
    if (isFavorite) {
      tags.push('favorites')
    }
    item.tags = tags;
  });
  return state.placesOnDisplayInHome;
}

export function favoritesFiltered(state: PlaceState) {
  let searchPlaces = searchText(state.searchTextInVisited);
  // let searchTags = filterByTag(state.tagFilters);

  function isFavorite(place: Place) {
    // return state.favorites.indexOf(place.id) !== -1;
  }

  return state.places
    .filter(isFavorite)
    .filter(searchPlaces)
    // .filter(searchTags);
}

export function loggedInFilteredPark(userState: UserState, placeState: PlaceState) {
  // const searchText = placeState.searchTextInVisited;
  // // const searchTags = filterByTag(placeState.tagFilters);
  // const filter = placeState.tagFilters[0] || 'visited';
  // const { parks } = userState[filter];
  // if (parks.length === 0) {
  //   return [];
  // }
  // const array = [];
  // const newParks = JSON.parse(JSON.stringify(parks));
  // Object.keys(newParks).forEach((key: string) => {
  //   const isInFullName = newParks[key].park_name.toLowerCase().includes(searchText.toLowerCase());
  //   if (isInFullName) {
  //     array.push(newParks.push)
  //   }
  // });

  // return userState[filter].parks.filter(searchText);
}

export function filteredPark(state: PlaceState) {
  const searchText = state.searchTextInVisited;
  if (!state.myList) {
    state.myList = {};
  }
  const newplaces = JSON.parse(JSON.stringify(state.myList));
  const searchTags = filterByTag(state.tagFilters);
  if (Object.keys(newplaces).length <= 0) {
    return [];
  }
  const array: Place[] = [];
  Object.keys(newplaces).forEach((key: string) => {
    const isInFullName = newplaces[key].name.toLowerCase().includes(searchText.toLowerCase());
    if (isInFullName) {
      array.push(newplaces[key])
    }
  });
  return array.filter(searchTags);
}

export function visitedFiltered(state: PlaceState) {
  const searchText = state.searchTextInVisited;
  if (!state.myList) {
    state.myList = {};
  }
  const newplaces = JSON.parse(JSON.stringify(state.myList));
  const searchTags = filterByTag(state.tagFilters);
  if (Object.keys(newplaces).length <= 0) {
    return [];
  }
  const array: Place[] = [];
  Object.keys(newplaces).forEach((key: string) => {
    const isInFullName = newplaces[key].name.toLowerCase().includes(searchText.toLowerCase());
    if (isInFullName) {
      array.push(newplaces[key])
    }
  })
  return array.filter(searchTags)
  // return array;
}

export function listCount (state: PlaceState) {
  let visitedCount = 0;
  let favoritesCount = 0;
  let bucketListCount = 0;
  if (!state.myList) {
    state.myList = {};
    return {
      visitedCount,
      favoritesCount,
      bucketListCount,
    };
  }
  Object.keys(state.myList).forEach((item) => {
    const { tags } = state.myList[item];
    if (!tags) {
      return;
    }
    visitedCount = tags.includes('visited') ? visitedCount + 1 : visitedCount;
    favoritesCount = tags.includes('favorites') ? favoritesCount + 1 : favoritesCount;
    bucketListCount = tags.includes('bucket') ? bucketListCount + 1 : bucketListCount;
  });
  return {
    visitedCount,
    favoritesCount,
    bucketListCount,
  };
}
export function visitedNoFilter(state: PlaceState) {
  if (!state.myList) {
    state.myList = {};
  }
  const newplaces = JSON.parse(JSON.stringify(state.myList));
  if (Object.keys(newplaces).length <= 0) {
    return [];
  }
  const array: Place[] = [];
  Object.keys(newplaces).forEach((key: string) => {
    array.push(newplaces[key])
  });
  return array;
}
export function bucketListFiltered(state: PlaceState) {
  const searchText = state.searchTextInBucketList;
  if (!state.myList) {
    state.myList = {};
  }
  const newplaces = JSON.parse(JSON.stringify(state.myList));
  const searchTags = filterByTag(['bucket']);
  if (Object.keys(newplaces).length <= 0) {
    return [];
  }
  const array: Place[] = [];
  Object.keys(newplaces).forEach((key: string) => {
    const isInFullName = newplaces[key].name.toLowerCase().includes(searchText.toLowerCase());
    if (isInFullName) {
      array.push(newplaces[key])
    }
  })
  return array.filter(searchTags);
}

function searchText(searchText: string) {
  if (!searchText) {
    return () => true;
  }
  const lowerSearchText = searchText.toLowerCase();
  return (place: Place) => place.name.toLowerCase().indexOf(lowerSearchText) !== -1;
}

function filterByTag(tagFilters: string[]) {
  if (tagFilters.length === 0) {
    return () => true;
  }
  return (place: Place) => {
    if (!place.tags) {
      return false;
    }
    return place.tags.some(placeTagName => (
      tagFilters.some(tagName => tagName === placeTagName)
    ))
  };
}

function filterByState(stateFilters: string[]) {
  if (stateFilters.length === 0) {
    return () => true;
  }
  return (place: Place) => (
    place.states.split(',').some(state => (
      stateFilters.some(tagName => tagName === state)
    ))
  );
}
